module.exports = __webpack_public_path__ + "./images/70a3742c4b15c6a2891c2dffac196103.webp";